import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import {
  type ResponseHeader,
  ResponseHeaderSchema,
} from '../responseHeader'
import {
  type AuthenticateSessionResponsePayload,
  AuthenticateSessionResponsePayloadSchema,
} from './authenticateSessionResponsePayload'

export type AuthenticateSessionResponse = {
  header: ResponseHeader
  payload?: AuthenticateSessionResponsePayload
}

export const AuthenticateSessionResponseSchema: CborSchema<AuthenticateSessionResponse> =
  defineCborSchema<AuthenticateSessionResponse>({
    header: CborField({ key: 0, type: ResponseHeaderSchema }),
    payload: CborField({ key: 1, required: false, type: AuthenticateSessionResponsePayloadSchema }),
  })
